
























import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import en from "vuetify/es5/locale/en";
import VueI18n from "vue-i18n";

@Component({
  components: {},
})
export default class MyNumberField extends Vue {
  @Prop({ default: "" }) id?: string;
  @Prop({ default: false }) required: boolean;
  @Prop({ default: true }) redIcon: boolean;
  @Prop({ default: "" }) label: string | VueI18n.TranslateResult;

  get identifier() {
    return this.id ? this.id : this.lodash.uniqueId(`mynumberfield-${new Date().getTime()}-`);
  }

  onInputCheck = `
    if (!this.max || !this.min) return;
    if (Number(this.value) > Number(this.max)) {
        this.value = this.max;
        return;
    };
    if (Number(this.value) < Number(this.min)) {
        this.value = this.min;
        return;
    };
    const decimalValue = (this.value+"").split(".")[1] || (this.value+"").split(",")[1];
    if (decimalValue && decimalValue.length) {
        const decimalValueMax = (this.max+"").split(".")[1] || (this.max+"").split(",")[1];
        if (Number(decimalValue) > Number(decimalValueMax)) {
            const intValue = (this.value+"").split(".")[0] || (this.value+"").split(",")[0];
            this.value = Number(intValue + '.' + decimalValue.slice(0, decimalValueMax.length));
            return;
        }
    }
  `;

  onKeyDownCheck = `return event.keyCode !== 69`;
}
